module.exports = __webpack_public_path__ + "images/icons_v2/refresh-a8a9556d.svg";